import CassieContainer from './CassieContainer';

interface CassieInjectorProps {
  contactId: string | undefined;
}

const CassieInjector: React.FC<CassieInjectorProps> = ({ contactId }) => {
  return <CassieContainer contactId={contactId} />;
};

export default CassieInjector;
